import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IMei from "Types/IMei";
import { State } from "store/reducers";

export const GET_COMPANY = "[COMPANY GET] GET_COMPANY";
export const GET_COMPANY_SUCCESS = "[COMPANY GET] GET_COMPANY_SUCCESS";
export const GET_COMPANY_FAILED = "[COMPANY GET] GET_COMPANY_FAILED";

export const SET_VALUE = "[COMPANY GET] SET_VALUE";
export const CLEAR_VALUES = "[COMPANY GET] CLEAR_VALUES";

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getCompany(id: string, callback?: Callback<IMei>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_COMPANY });

		try {
			const { login } = getState() as State;

			const response = await api.sendGet("/Mei/" + id, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_COMPANY_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_COMPANY_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: GET_COMPANY_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
